import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import WorklogDetail from './WorklogDetail';

function WorklogDetailModal({ worklogId }, ref) {
    const [currentWorklogId, setCurrentWorklogId] = useState(null);
    const modalId = uuid();
    const modalElementRef = useRef();
    const modalRef = useRef();
    
    useImperativeHandle(ref, () => ({
        initViewModalHandler: (worklogId) => {
            setCurrentWorklogId(worklogId);
            openModal(); 
        }
    }));

    useEffect(() => {
        modalElementRef.current = document.getElementById(modalId);
        modalRef.current = new Modal(modalElementRef.current, { keyboard: false, backdrop: false });
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);

    const openModal = () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    
    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }

    return (
        <div
            className="modal fade"
            id={modalId}
            ref={modalElementRef}
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Worklog Details</h5> 
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            onClick={closeModal}
                            aria-label="Close"
                        ></button>
                    </div>

                    <div className="modal-body">
                       {currentWorklogId && (
                            <WorklogDetail worklogId={currentWorklogId} />
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            onClick={closeModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(WorklogDetailModal);